import { useState } from 'react';
import { VideoCard } from 'components/VideoCard';
import { FormModal } from './FormModal';

export const EditModalButton = ({ data, disabled = false }) => {
  const [open, setOpen] = useState(false);
  const closeModal = () => setOpen(false);
  const openModal = () => setOpen(true);

  return (
    <>
      <VideoCard.ActionButton
        action="viewEdit"
        disabled={disabled}
        onClick={openModal}
        data-no-dnd="true"
      />
      {open && <FormModal data={data} open={open} onClose={closeModal} />}
    </>
  );
};
